import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import i18n from '../i18n'
import money from 'v-money'

// Helpers
import colors from 'vuetify/es5/util/colors'

Vue.use(money)
Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: colors.orange.lighten1,
    secondary: colors.orange.darken4,
    accent: colors.blue.base,
  },
  options: {
    customProperties: true
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  }
})